import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Database = {
  public: {
    Tables: {
      sales_coach_chat: {
        Row: {
          message_id: string;
          role: string | null;
          content: string | null;
          sent_to_user: string | null;
          created_at: string;
          updated_at: string | null;
          session_title: string | null;
          session_created_at: string;
          session_updated_at: string;
          chat_thread_id: string | null;
          client_id: string | null;
          user_id: string | null;
          context_type: string | null;
          context_params: Record<string, string> | null;
        };
        Insert: {
          message_id?: string;
          role?: string | null;
          content?: string | null;
          sent_to_user?: string | null;
          created_at?: string;
          updated_at?: string | null;
          session_title?: string | null;
          session_created_at?: string;
          session_updated_at?: string;
          chat_thread_id?: string | null;
          client_id?: string | null;
          user_id?: string | null;
          context_type?: string | null;
          context_params?: Record<string, string> | null;
        };
        Update: {
          message_id?: string;
          role?: string | null;
          content?: string | null;
          sent_to_user?: string | null;
          created_at?: string;
          updated_at?: string | null;
          session_title?: string | null;
          session_created_at?: string;
          session_updated_at?: string;
          chat_thread_id?: string | null;
          client_id?: string | null;
          user_id?: string | null;
          context_type?: string | null;
          context_params?: Record<string, string> | null;
        };
      };
      pre_qualified_leads: {
        Row: {
          id: string;
          lead_id: string | null;
          company_name: string | null;
          company_website: string | null;
          company_linkedin: string | null;
          company_phone: string | null;
          country: string | null;
          employee_headcount: string | null;
          industry_1: string | null;
          industry_2: string | null;
          products_services: string | null;
          company_type: string | null;
          dm_full_name: string | null;
          dm_title: string | null;
          dm_email_1: string | null;
          dm_email_2: string | null;
          dm_mobile_1: string | null;
          dm_mobile_2: string | null;
          dm_linkedin: string | null;
          company_qualified: boolean;
          dm_qualified: boolean;
          mobile_verified: boolean;
          email_verified: boolean;
          linkedin_verified: boolean;
          validation_score: number;
          qualification_score: number;
          lead_status: string | null;
          cp_disq_reason: string | null;
          created_at: string;
          updated_at: string;
          _rowIndex: number | null;
        };
        Insert: {
          id?: string;
          lead_id?: string | null;
          company_name?: string | null;
          company_website?: string | null;
          company_linkedin?: string | null;
          company_phone?: string | null;
          country?: string | null;
          employee_headcount?: string | null;
          industry_1?: string | null;
          industry_2?: string | null;
          products_services?: string | null;
          company_type?: string | null;
          dm_full_name?: string | null;
          dm_title?: string | null;
          dm_email_1?: string | null;
          dm_email_2?: string | null;
          dm_mobile_1?: string | null;
          dm_mobile_2?: string | null;
          dm_linkedin?: string | null;
          company_qualified?: boolean;
          dm_qualified?: boolean;
          mobile_verified?: boolean;
          email_verified?: boolean;
          linkedin_verified?: boolean;
          validation_score?: number;
          qualification_score?: number;
          lead_status?: string | null;
          cp_disq_reason?: string | null;
          created_at?: string;
          updated_at?: string;
          _rowIndex?: number | null;
        };
        Update: {
          id?: string;
          lead_id?: string | null;
          company_name?: string | null;
          company_website?: string | null;
          company_linkedin?: string | null;
          company_phone?: string | null;
          country?: string | null;
          employee_headcount?: string | null;
          industry_1?: string | null;
          industry_2?: string | null;
          products_services?: string | null;
          company_type?: string | null;
          dm_full_name?: string | null;
          dm_title?: string | null;
          dm_email_1?: string | null;
          dm_email_2?: string | null;
          dm_mobile_1?: string | null;
          dm_mobile_2?: string | null;
          dm_linkedin?: string | null;
          company_qualified?: boolean;
          dm_qualified?: boolean;
          mobile_verified?: boolean;
          email_verified?: boolean;
          linkedin_verified?: boolean;
          validation_score?: number;
          qualification_score?: number;
          lead_status?: string | null;
          cp_disq_reason?: string | null;
          created_at?: string;
          updated_at?: string;
          _rowIndex?: number | null;
        };
      };
      qualified_leads: {
        Row: {
          id: string;
          lead_id: string | null;
          company_name: string | null;
          company_website: string | null;
          company_linkedin: string | null;
          company_phone: string | null;
          country: string | null;
          employee_headcount: string | null;
          industry_1: string | null;
          industry_2: string | null;
          products_services: string | null;
          company_type: string | null;
          dm_full_name: string | null;
          dm_title: string | null;
          dm_email_1: string | null;
          dm_email_2: string | null;
          dm_mobile_1: string | null;
          dm_mobile_2: string | null;
          dm_linkedin: string | null;
          company_qualified: boolean;
          dm_qualified: boolean;
          mobile_verified: boolean;
          email_verified: boolean;
          linkedin_verified: boolean;
          validation_score: number;
          qualification_score: number;
          lead_status: string | null;
          send_for_outreach: string | null;
          sent_to_ca: boolean;
          sent_to_wa: boolean;
          sent_to_ea: boolean;
          sent_to_la: boolean;
          created_at: string;
          updated_at: string;
          _rowIndex: number | null;
        };
        Insert: {
          id?: string;
          lead_id?: string | null;
          company_name?: string | null;
          company_website?: string | null;
          company_linkedin?: string | null;
          company_phone?: string | null;
          country?: string | null;
          employee_headcount?: string | null;
          industry_1?: string | null;
          industry_2?: string | null;
          products_services?: string | null;
          company_type?: string | null;
          dm_full_name?: string | null;
          dm_title?: string | null;
          dm_email_1?: string | null;
          dm_email_2?: string | null;
          dm_mobile_1?: string | null;
          dm_mobile_2?: string | null;
          dm_linkedin?: string | null;
          company_qualified?: boolean;
          dm_qualified?: boolean;
          mobile_verified?: boolean;
          email_verified?: boolean;
          linkedin_verified?: boolean;
          validation_score?: number;
          qualification_score?: number;
          lead_status?: string | null;
          send_for_outreach?: string | null;
          sent_to_ca?: boolean;
          sent_to_wa?: boolean;
          sent_to_ea?: boolean;
          sent_to_la?: boolean;
          created_at?: string;
          updated_at?: string;
          _rowIndex?: number | null;
        };
        Update: {
          id?: string;
          lead_id?: string | null;
          company_name?: string | null;
          company_website?: string | null;
          company_linkedin?: string | null;
          company_phone?: string | null;
          country?: string | null;
          employee_headcount?: string | null;
          industry_1?: string | null;
          industry_2?: string | null;
          products_services?: string | null;
          company_type?: string | null;
          dm_full_name?: string | null;
          dm_title?: string | null;
          dm_email_1?: string | null;
          dm_email_2?: string | null;
          dm_mobile_1?: string | null;
          dm_mobile_2?: string | null;
          dm_linkedin?: string | null;
          company_qualified?: boolean;
          dm_qualified?: boolean;
          mobile_verified?: boolean;
          email_verified?: boolean;
          linkedin_verified?: boolean;
          validation_score?: number;
          qualification_score?: number;
          lead_status?: string | null;
          send_for_outreach?: string | null;
          sent_to_ca?: boolean;
          sent_to_wa?: boolean;
          sent_to_ea?: boolean;
          sent_to_la?: boolean;
          created_at?: string;
          updated_at?: string;
          _rowIndex?: number | null;
        };
      };
      call_agent_leads: {
        Row: {
          id: string;
          lead_id: string | null;
          company_name: string | null;
          company_website: string | null;
          company_linkedin: string | null;
          industry_1: string | null;
          country: string | null;
          dm_full_name: string | null;
          dm_title: string | null;
          dm_mobile_1: string | null;
          dm_mobile_2: string | null;
          dm_linkedin: string | null;
          call_attempts: number;
          pickups: number;
          last_call_outcome: string | null;
          last_call_timestamp: string | null;
          last_call_transcript: string | null;
          next_call: string | null;
          lead_temprature: string | null;
          lead_status: string | null;
          ovrall_calls_convo_summary: string | null;
          calls_convo_history_summarized: string | null;
          conversation_history: string | null;
          created_at: string;
          updated_at: string;
          _rowIndex: number | null;
        };
        Insert: {
          id?: string;
          lead_id?: string | null;
          company_name?: string | null;
          company_website?: string | null;
          company_linkedin?: string | null;
          industry_1?: string | null;
          country?: string | null;
          dm_full_name?: string | null;
          dm_title?: string | null;
          dm_mobile_1?: string | null;
          dm_mobile_2?: string | null;
          dm_linkedin?: string | null;
          call_attempts?: number;
          pickups?: number;
          last_call_outcome?: string | null;
          last_call_timestamp?: string | null;
          last_call_transcript?: string | null;
          next_call?: string | null;
          lead_temprature?: string | null;
          lead_status?: string | null;
          ovrall_calls_convo_summary?: string | null;
          calls_convo_history_summarized?: string | null;
          conversation_history?: string | null;
          created_at?: string;
          updated_at?: string;
          _rowIndex?: number | null;
        };
        Update: {
          id?: string;
          lead_id?: string | null;
          company_name?: string | null;
          company_website?: string | null;
          company_linkedin?: string | null;
          industry_1?: string | null;
          country?: string | null;
          dm_full_name?: string | null;
          dm_title?: string | null;
          dm_mobile_1?: string | null;
          dm_mobile_2?: string | null;
          dm_linkedin?: string | null;
          call_attempts?: number;
          pickups?: number;
          last_call_outcome?: string | null;
          last_call_timestamp?: string | null;
          last_call_transcript?: string | null;
          next_call?: string | null;
          lead_temprature?: string | null;
          lead_status?: string | null;
          ovrall_calls_convo_summary?: string | null;
          calls_convo_history_summarized?: string | null;
          conversation_history?: string | null;
          created_at?: string;
          updated_at?: string;
          _rowIndex?: number | null;
        };
      };
      whatsapp_agent_leads: {
        Row: {
          id: string;
          lead_id: string | null;
          company_name: string | null;
          company_website: string | null;
          company_linkedin: string | null;
          industry_1: string | null;
          country: string | null;
          dm_full_name: string | null;
          dm_title: string | null;
          dm_mobile_1: string | null;
          dm_mobile_2: string | null;
          dm_linkedin: string | null;
          messages_sent: number;
          replies_received: number;
          last_message_timestamp: string | null;
          last_reply_timestamp: string | null;
          next_fu_datetime: string | null;
          lead_temprature: string | null;
          lead_status: string | null;
          wa_convo_summary: string | null;
          wa_convo_history: string | null;
          created_at: string;
          updated_at: string;
          _rowIndex: number | null;
        };
        Insert: {
          id?: string;
          lead_id?: string | null;
          company_name?: string | null;
          company_website?: string | null;
          company_linkedin?: string | null;
          industry_1?: string | null;
          country?: string | null;
          dm_full_name?: string | null;
          dm_title?: string | null;
          dm_mobile_1?: string | null;
          dm_mobile_2?: string | null;
          dm_linkedin?: string | null;
          messages_sent?: number;
          replies_received?: number;
          last_message_timestamp?: string | null;
          last_reply_timestamp?: string | null;
          next_fu_datetime?: string | null;
          lead_temprature?: string | null;
          lead_status?: string | null;
          wa_convo_summary?: string | null;
          wa_convo_history?: string | null;
          created_at?: string;
          updated_at?: string;
          _rowIndex?: number | null;
        };
        Update: {
          id?: string;
          lead_id?: string | null;
          company_name?: string | null;
          company_website?: string | null;
          company_linkedin?: string | null;
          industry_1?: string | null;
          country?: string | null;
          dm_full_name?: string | null;
          dm_title?: string | null;
          dm_mobile_1?: string | null;
          dm_mobile_2?: string | null;
          dm_linkedin?: string | null;
          messages_sent?: number;
          replies_received?: number;
          last_message_timestamp?: string | null;
          last_reply_timestamp?: string | null;
          next_fu_datetime?: string | null;
          lead_temprature?: string | null;
          lead_status?: string | null;
          wa_convo_summary?: string | null;
          wa_convo_history?: string | null;
          created_at?: string;
          updated_at?: string;
          _rowIndex?: number | null;
        };
      };
      email_agent_leads: {
        Row: {
          id: string;
          lead_id: string | null;
          company_name: string | null;
          company_website: string | null;
          company_linkedin: string | null;
          industry_1: string | null;
          country: string | null;
          dm_full_name: string | null;
          dm_title: string | null;
          dm_email_1: string | null;
          dm_email_2: string | null;
          dm_linkedin: string | null;
          emails_sent: number;
          replies_received: number;
          last_email_timestamp: string | null;
          last_reply_timestamp: string | null;
          next_fu_datetime: string | null;
          lead_temprature: string | null;
          lead_status: string | null;
          email_convo_summary: string | null;
          email_convo_history: string | null;
          created_at: string;
          updated_at: string;
          _rowIndex: number | null;
        };
        Insert: {
          id?: string;
          lead_id?: string | null;
          company_name?: string | null;
          company_website?: string | null;
          company_linkedin?: string | null;
          industry_1?: string | null;
          country?: string | null;
          dm_full_name?: string | null;
          dm_title?: string | null;
          dm_email_1?: string | null;
          dm_email_2?: string | null;
          dm_linkedin?: string | null;
          emails_sent?: number;
          replies_received?: number;
          last_email_timestamp?: string | null;
          last_reply_timestamp?: string | null;
          next_fu_datetime?: string | null;
          lead_temprature?: string | null;
          lead_status?: string | null;
          email_convo_summary?: string | null;
          email_convo_history?: string | null;
          created_at?: string;
          updated_at?: string;
          _rowIndex?: number | null;
        };
        Update: {
          id?: string;
          lead_id?: string | null;
          company_name?: string | null;
          company_website?: string | null;
          company_linkedin?: string | null;
          industry_1?: string | null;
          country?: string | null;
          dm_full_name?: string | null;
          dm_title?: string | null;
          dm_email_1?: string | null;
          dm_email_2?: string | null;
          dm_linkedin?: string | null;
          emails_sent?: number;
          replies_received?: number;
          last_email_timestamp?: string | null;
          last_reply_timestamp?: string | null;
          next_fu_datetime?: string | null;
          lead_temprature?: string | null;
          lead_status?: string | null;
          email_convo_summary?: string | null;
          email_convo_history?: string | null;
          created_at?: string;
          updated_at?: string;
          _rowIndex?: number | null;
        };
      };
      linkedin_agent_leads: {
        Row: {
          id: string;
          lead_id: string | null;
          company_name: string | null;
          company_website: string | null;
          company_linkedin: string | null;
          industry_1: string | null;
          country: string | null;
          dm_full_name: string | null;
          dm_title: string | null;
          dm_linkedin: string | null;
          connection_request_sent: boolean;
          connection_accepted: boolean;
          lkdin_msgs_sent: number;
          lkdin_replies: number;
          last_message_timestamp: string | null;
          last_reply_timestamp: string | null;
          next_fu_datetime: string | null;
          lead_temprature: string | null;
          lead_status: string | null;
          lkdin_convo_summary: string | null;
          lkdin_convo_history: string | null;
          created_at: string;
          updated_at: string;
          _rowIndex: number | null;
        };
        Insert: {
          id?: string;
          lead_id?: string | null;
          company_name?: string | null;
          company_website?: string | null;
          company_linkedin?: string | null;
          industry_1?: string | null;
          country?: string | null;
          dm_full_name?: string | null;
          dm_title?: string | null;
          dm_linkedin?: string | null;
          connection_request_sent?: boolean;
          connection_accepted?: boolean;
          lkdin_msgs_sent?: number;
          lkdin_replies?: number;
          last_message_timestamp?: string | null;
          last_reply_timestamp?: string | null;
          next_fu_datetime?: string | null;
          lead_temprature?: string | null;
          lead_status?: string | null;
          lkdin_convo_summary?: string | null;
          lkdin_convo_history?: string | null;
          created_at?: string;
          updated_at?: string;
          _rowIndex?: number | null;
        };
        Update: {
          id?: string;
          lead_id?: string | null;
          company_name?: string | null;
          company_website?: string | null;
          company_linkedin?: string | null;
          industry_1?: string | null;
          country?: string | null;
          dm_full_name?: string | null;
          dm_title?: string | null;
          dm_linkedin?: string | null;
          connection_request_sent?: boolean;
          connection_accepted?: boolean;
          lkdin_msgs_sent?: number;
          lkdin_replies?: number;
          last_message_timestamp?: string | null;
          last_reply_timestamp?: string | null;
          next_fu_datetime?: string | null;
          lead_temprature?: string | null;
          lead_status?: string | null;
          lkdin_convo_summary?: string | null;
          lkdin_convo_history?: string | null;
          created_at?: string;
          updated_at?: string;
          _rowIndex?: number | null;
        };
      };
      meetings: {
        Row: {
          id: string;
          meeting_id: string | null;
          lead_id: string | null;
          company_name: string | null;
          company_website: string | null;
          company_linkedin: string | null;
          industry_1: string | null;
          country: string | null;
          dm_full_name: string | null;
          dm_title: string | null;
          dm_email_1: string | null;
          dm_mobile_1: string | null;
          dm_linkedin: string | null;
          meeting_date: string | null;
          meeting_time: string | null;
          date_booked: string | null;
          meeting_status: string | null;
          assigned_to_sales_person: string | null;
          channel: string | null;
          pipeline_stage: string | null;
          meeting_link: string | null;
          meeting_notes: string | null;
          meeting_outcome: string | null;
          created_at: string;
          updated_at: string;
          _rowIndex: number | null;
        };
        Insert: {
          id?: string;
          meeting_id?: string | null;
          lead_id?: string | null;
          company_name?: string | null;
          company_website?: string | null;
          company_linkedin?: string | null;
          industry_1?: string | null;
          country?: string | null;
          dm_full_name?: string | null;
          dm_title?: string | null;
          dm_email_1?: string | null;
          dm_mobile_1?: string | null;
          dm_linkedin?: string | null;
          meeting_date?: string | null;
          meeting_time?: string | null;
          date_booked?: string | null;
          meeting_status?: string | null;
          assigned_to_sales_person?: string | null;
          channel?: string | null;
          pipeline_stage?: string | null;
          meeting_link?: string | null;
          meeting_notes?: string | null;
          meeting_outcome?: string | null;
          created_at?: string;
          updated_at?: string;
          _rowIndex?: number | null;
        };
        Update: {
          id?: string;
          meeting_id?: string | null;
          lead_id?: string | null;
          company_name?: string | null;
          company_website?: string | null;
          company_linkedin?: string | null;
          industry_1?: string | null;
          country?: string | null;
          dm_full_name?: string | null;
          dm_title?: string | null;
          dm_email_1?: string | null;
          dm_mobile_1?: string | null;
          dm_linkedin?: string | null;
          meeting_date?: string | null;
          meeting_time?: string | null;
          date_booked?: string | null;
          meeting_status?: string | null;
          assigned_to_sales_person?: string | null;
          channel?: string | null;
          pipeline_stage?: string | null;
          meeting_link?: string | null;
          meeting_notes?: string | null;
          meeting_outcome?: string | null;
          created_at?: string;
          updated_at?: string;
          _rowIndex?: number | null;
        };
      };
      pipeline_leads: {
        Row: {
          id: string;
          lead_id: string | null;
          company_name: string | null;
          company_website: string | null;
          company_linkedin: string | null;
          industry_1: string | null;
          country: string | null;
          dm_full_name: string | null;
          dm_title: string | null;
          dm_email_1: string | null;
          dm_mobile_1: string | null;
          dm_linkedin: string | null;
          pipeline_stage: string | null;
          lead_status: string | null;
          deal_value: number;
          channel: string | null;
          last_reply_timestamp: string | null;
          next_fu_datetime: string | null;
          proposal_sent: boolean;
          proposal_sent_date: string | null;
          agreement_sent: boolean;
          agreement_sent_date: string | null;
          closed_date: string | null;
          lost_reason: string | null;
          created_at: string;
          updated_at: string;
          _rowIndex: number | null;
        };
        Insert: {
          id?: string;
          lead_id?: string | null;
          company_name?: string | null;
          company_website?: string | null;
          company_linkedin?: string | null;
          industry_1?: string | null;
          country?: string | null;
          dm_full_name?: string | null;
          dm_title?: string | null;
          dm_email_1?: string | null;
          dm_mobile_1?: string | null;
          dm_linkedin?: string | null;
          pipeline_stage?: string | null;
          lead_status?: string | null;
          deal_value?: number;
          channel?: string | null;
          last_reply_timestamp?: string | null;
          next_fu_datetime?: string | null;
          proposal_sent?: boolean;
          proposal_sent_date?: string | null;
          agreement_sent?: boolean;
          agreement_sent_date?: string | null;
          closed_date?: string | null;
          lost_reason?: string | null;
          created_at?: string;
          updated_at?: string;
          _rowIndex?: number | null;
        };
        Update: {
          id?: string;
          lead_id?: string | null;
          company_name?: string | null;
          company_website?: string | null;
          company_linkedin?: string | null;
          industry_1?: string | null;
          country?: string | null;
          dm_full_name?: string | null;
          dm_title?: string | null;
          dm_email_1?: string | null;
          dm_mobile_1?: string | null;
          dm_linkedin?: string | null;
          pipeline_stage?: string | null;
          lead_status?: string | null;
          deal_value?: number;
          channel?: string | null;
          last_reply_timestamp?: string | null;
          next_fu_datetime?: string | null;
          proposal_sent?: boolean;
          proposal_sent_date?: string | null;
          agreement_sent?: boolean;
          agreement_sent_date?: string | null;
          closed_date?: string | null;
          lost_reason?: string | null;
          created_at?: string;
          updated_at?: string;
          _rowIndex?: number | null;
        };
      };
      lead_tracking: {
        Row: {
          id: string;
          lead_id: string | null;
          company_name: string | null;
          dm_full_name: string | null;
          lead_generated_timestamp: string | null;
          outreach_start_timestamp: string | null;
          date_booked: string | null;
          meeting_date: string | null;
          ovrall_lead_status: string | null;
          ovrall_lead_temp: string | null;
          all_convo_summary: string | null;
          call_attempts: number;
          call_answered: number;
          last_call_outcome: string | null;
          ovrall_calls_convo_summary: string | null;
          whatsapps_sent: number;
          whatsapp_replies: number;
          wa_convo_outcome: string | null;
          wa_convo_summary: string | null;
          emails_sent: number;
          email_replies: number;
          email_convo_outcome: string | null;
          email_convo_summary: string | null;
          lkdin_msgs_sent: number;
          lkdin_replies: number;
          lkdin_convo_outcome: string | null;
          lkdin_convo_summary: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          lead_id?: string | null;
          company_name?: string | null;
          dm_full_name?: string | null;
          lead_generated_timestamp?: string | null;
          outreach_start_timestamp?: string | null;
          date_booked?: string | null;
          meeting_date?: string | null;
          ovrall_lead_status?: string | null;
          ovrall_lead_temp?: string | null;
          all_convo_summary?: string | null;
          call_attempts?: number;
          call_answered?: number;
          last_call_outcome?: string | null;
          ovrall_calls_convo_summary?: string | null;
          whatsapps_sent?: number;
          whatsapp_replies?: number;
          wa_convo_outcome?: string | null;
          wa_convo_summary?: string | null;
          emails_sent?: number;
          email_replies?: number;
          email_convo_outcome?: string | null;
          email_convo_summary?: string | null;
          lkdin_msgs_sent?: number;
          lkdin_replies?: number;
          lkdin_convo_outcome?: string | null;
          lkdin_convo_summary?: string | null;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          lead_id?: string | null;
          company_name?: string | null;
          dm_full_name?: string | null;
          lead_generated_timestamp?: string | null;
          outreach_start_timestamp?: string | null;
          date_booked?: string | null;
          meeting_date?: string | null;
          ovrall_lead_status?: string | null;
          ovrall_lead_temp?: string | null;
          all_convo_summary?: string | null;
          call_attempts?: number;
          call_answered?: number;
          last_call_outcome?: string | null;
          ovrall_calls_convo_summary?: string | null;
          whatsapps_sent?: number;
          whatsapp_replies?: number;
          wa_convo_outcome?: string | null;
          wa_convo_summary?: string | null;
          emails_sent?: number;
          email_replies?: number;
          email_convo_outcome?: string | null;
          email_convo_summary?: string | null;
          lkdin_msgs_sent?: number;
          lkdin_replies?: number;
          lkdin_convo_outcome?: string | null;
          lkdin_convo_summary?: string | null;
          created_at?: string;
          updated_at?: string;
        };
      };
      call_logs: {
        Row: {
          id: string;
          call_id_internal: string;
          lead_id: string | null;
          client_id: string | null;
          user_id: string | null;
          campaign_id: string | null;
          company_name: string | null;
          agent_name: string | null;
          dm_full_name: string | null;
          call_outcome: string | null;
          time_stamp: string | null;
          call_recording_url: string | null;
          call_recording: string | null;
          call_transcript: string | null;
          call_summary: string | null;
          call_attempt: number | null;
          call_id_vapi: string | null;
          created_at: string;
        };
        Insert: {
          id?: string;
          call_id_internal?: string;
          lead_id?: string | null;
          client_id?: string | null;
          user_id?: string | null;
          campaign_id?: string | null;
          company_name?: string | null;
          agent_name?: string | null;
          dm_full_name?: string | null;
          call_outcome?: string | null;
          time_stamp?: string | null;
          call_recording_url?: string | null;
          call_recording?: string | null;
          call_transcript?: string | null;
          call_summary?: string | null;
          call_attempt?: number | null;
          call_id_vapi?: string | null;
          created_at?: string;
        };
        Update: {
          id?: string;
          call_id_internal?: string;
          lead_id?: string | null;
          client_id?: string | null;
          user_id?: string | null;
          campaign_id?: string | null;
          company_name?: string | null;
          agent_name?: string | null;
          dm_full_name?: string | null;
          call_outcome?: string | null;
          time_stamp?: string | null;
          call_recording_url?: string | null;
          call_recording?: string | null;
          call_transcript?: string | null;
          call_summary?: string | null;
          call_attempt?: number | null;
          call_id_vapi?: string | null;
          created_at?: string;
        };
      };
      whatsapp_logs: {
        Row: {
          wa_message_id_internal: string;
          wa_convo_id_internal: string | null;
          lead_id: string | null;
          client_id: string | null;
          user_id: string | null;
          campaign_id: string | null;
          from_role: string | null;
          message_text: string | null;
          message_type: string | null;
          status: string | null;
          created_at: string;
        };
        Insert: Record<string, unknown>;
        Update: Record<string, unknown>;
      };
      email_logs: {
        Row: {
          email_id_internal: string;
          email_convo_id_internal: string | null;
          lead_id: string | null;
          client_id: string | null;
          user_id: string | null;
          campaign_id: string | null;
          from_role: string | null;
          email_text: string | null;
          email_subject_line_text: string | null;
          status: string | null;
          email_mode: string | null;
          created_at: string;
        };
        Insert: Record<string, unknown>;
        Update: Record<string, unknown>;
      };
      linkedin_logs: {
        Row: {
          lkdin_message_id_internal: string;
          lkdin_convo_id_internal: string | null;
          lead_id: string | null;
          client_id: string | null;
          user_id: string | null;
          campaign_id: string | null;
          from_role: string | null;
          message_text: string | null;
          message_type: string | null;
          status: string | null;
          created_at: string;
        };
        Insert: Record<string, unknown>;
        Update: Record<string, unknown>;
      };
      linkedin_usage: {
        Row: {
          id: string;
          linkedin_account_id: string | null;
          client_id: string | null;
          user_id: string | null;
          date: string;
          invites_sent: number | null;
          messages_sent: number | null;
          profile_lookups: number | null;
          last_action_at: string | null;
          created_at: string;
        };
        Insert: Record<string, unknown>;
        Update: Record<string, unknown>;
      };
      meetings_booked: {
        Row: {
          meeting_id: string;
          lead_id: string | null;
          client_id: string | null;
          user_id: string | null;
          meeting_booked_at: string | null;
          meeting_date: string | null;
          meeting_time: string | null;
          meeting_status: string | null;
          booked_channel: string | null;
          sales_person: string | null;
          created_at: string;
        };
        Insert: Record<string, unknown>;
        Update: Record<string, unknown>;
      };
      leads_tracking: {
        Row: {
          lead_id: string;
          company_name: string | null;
          company_phone: string | null;
          company_website: string | null;
          company_linkedin: string | null;
          company_country: string | null;
          time_zone: string | null;
          employee_headcount: number | null;
          industry_1: string | null;
          industry_2: string | null;
          products_services: string | null;
          company_type: string | null;
          dm_full_name: string | null;
          dm_title: string | null;
          dm_mobile_1: string | null;
          dm_mobile_2: string | null;
          dm_email_1: string | null;
          dm_email_2: string | null;
          dm_linkedin: string | null;
          mobile_verified: boolean | null;
          email_verified: boolean | null;
          linkedin_verified: boolean | null;
          company_qualified: boolean | null;
          dm_qualified: boolean | null;
          ca_lead_status: string | null;
          ca_lead_temp: string | null;
          ca_last_call_outcome: string | null;
          ca_call_attempts: number | null;
          ca_call_answered: number | null;
          ca_last_call_transcript: string | null;
          ca_last_call_summary: string | null;
          ca_last_call_recording: string | null;
          ca_next_call_timestamp: string | null;
          ca_followup_status: string | null;
          ca_qualified: string | null;
          ca_calls_convo_history_summarized: string | null;
          ca_ovrall_calls_convo_summary: string | null;
          ca_first_call_schedule: string | null;
          ca_call_later_aut: string | null;
          ca_send_info_aut: string | null;
          wa_lead_status: string | null;
          wa_lead_temp: string | null;
          wa_messages_sent: number | null;
          wa_replies_received: number | null;
          wa_last_reply_timestamp: string | null;
          wa_followup_status: string | null;
          wa_next_fu_datetime: string | null;
          wa_fus_done: number | null;
          wa_qualified: string | null;
          wa_convo_outcome: string | null;
          wa_conversation_thread: string | null;
          wa_convo_summary: string | null;
          wa_first_message_status: string | null;
          wa_failed_messages: number | null;
          wa_conversation_thread_id: string | null;
          wa_number_id: string | null;
          wa_agent_name: string | null;
          ea_lead_status: string | null;
          ea_lead_temp: string | null;
          ea_emails_sent: number | null;
          ea_replies_received: number | null;
          ea_last_reply_timestamp: string | null;
          ea_followup_status: string | null;
          ea_next_fu_datetime: string | null;
          ea_fus_done: number | null;
          ea_qualified: string | null;
          ea_first_email_status: string | null;
          ea_last_email_status: string | null;
          ea_failed_emails: number | null;
          ea_emails_sq_sent: number | null;
          ea_email_1_sq_timestamp: string | null;
          ea_email_2_sq_timestamp: string | null;
          ea_email_3_sq_timestamp: string | null;
          ea_email_4_sq_timestamp: string | null;
          ea_email_5_sq_timestamp: string | null;
          ea_email_thread: string | null;
          ea_convo_outcome: string | null;
          ea_convo_summary: string | null;
          ea_conversation_thread_id: string | null;
          la_lead_status: string | null;
          la_lead_temp: string | null;
          la_cr_sent: string | null;
          la_cr_accepted: string | null;
          la_cr_accepted_at: string | null;
          la_messages_sent: number | null;
          la_replies_received: number | null;
          la_last_reply_timestamp: string | null;
          la_followup_status: string | null;
          la_next_fu_datetime: string | null;
          la_fus_done: number | null;
          la_qualified: string | null;
          la_conversation_thread_id: string | null;
          la_dm_linkedin_vmid: string | null;
          la_last_thread_sync_timestamp: string | null;
          la_conversation_thread: string | null;
          la_convo_outcome: string | null;
          la_convo_summary: string | null;
          campaign_id: string | null;
          campaign_step: number | null;
          meeting_booked: string | null;
          meeting_booking_timestamp: string | null;
          booked_agent: string | null;
          mtg_invite_sent: string | null;
          mtg_reschd_invite_sent: string | null;
          mtg_invite_cancelled: string | null;
          meeting_id: string | null;
          meeting_date: string | null;
          meeting_time: string | null;
          meeting_status: string | null;
          mtg_transcript: string | null;
          mtg_recording: string | null;
          deal_created: string | null;
          deal_id: string | null;
          pipeline_stage: string | null;
          sales_person: string | null;
          ovrall_lead_status: string | null;
          ovrall_lead_temp: string | null;
          ovrall_convo_summary: string | null;
          created_at: string | null;
          updated_at: string | null;
          outreach_start_timestamp: string | null;
          lead_source: string | null;
          sent_for_outreach: boolean | null;
          sent_to_ca: boolean | null;
          sent_to_wa: boolean | null;
          sent_to_ea: boolean | null;
          sent_to_la: boolean | null;
          assigned_to_campaign: boolean | null;
          lga_lead_status: string | null;
          send_for_outreach: string | null;
        };
        Insert: {
          lead_id?: string;
          company_name?: string | null;
          company_phone?: string | null;
          company_website?: string | null;
          company_linkedin?: string | null;
          company_country?: string | null;
          time_zone?: string | null;
          employee_headcount?: number | null;
          industry_1?: string | null;
          industry_2?: string | null;
          products_services?: string | null;
          company_type?: string | null;
          dm_full_name?: string | null;
          dm_title?: string | null;
          dm_mobile_1?: string | null;
          dm_mobile_2?: string | null;
          dm_email_1?: string | null;
          dm_email_2?: string | null;
          dm_linkedin?: string | null;
          mobile_verified?: boolean | null;
          email_verified?: boolean | null;
          linkedin_verified?: boolean | null;
          company_qualified?: boolean | null;
          dm_qualified?: boolean | null;
          ca_lead_status?: string | null;
          ca_lead_temp?: string | null;
          ca_last_call_outcome?: string | null;
          ca_call_attempts?: number | null;
          ca_call_answered?: number | null;
          ca_last_call_transcript?: string | null;
          ca_last_call_summary?: string | null;
          ca_last_call_recording?: string | null;
          ca_next_call_timestamp?: string | null;
          ca_followup_status?: string | null;
          ca_qualified?: string | null;
          ca_calls_convo_history_summarized?: string | null;
          ca_ovrall_calls_convo_summary?: string | null;
          ca_first_call_schedule?: string | null;
          ca_call_later_aut?: string | null;
          ca_send_info_aut?: string | null;
          wa_lead_status?: string | null;
          wa_lead_temp?: string | null;
          wa_messages_sent?: number | null;
          wa_replies_received?: number | null;
          wa_last_reply_timestamp?: string | null;
          wa_followup_status?: string | null;
          wa_next_fu_datetime?: string | null;
          wa_fus_done?: number | null;
          wa_qualified?: string | null;
          wa_convo_outcome?: string | null;
          wa_conversation_thread?: string | null;
          wa_convo_summary?: string | null;
          wa_first_message_status?: string | null;
          wa_failed_messages?: number | null;
          wa_conversation_thread_id?: string | null;
          wa_number_id?: string | null;
          wa_agent_name?: string | null;
          ea_lead_status?: string | null;
          ea_lead_temp?: string | null;
          ea_emails_sent?: number | null;
          ea_replies_received?: number | null;
          ea_last_reply_timestamp?: string | null;
          ea_followup_status?: string | null;
          ea_next_fu_datetime?: string | null;
          ea_fus_done?: number | null;
          ea_qualified?: string | null;
          ea_first_email_status?: string | null;
          ea_last_email_status?: string | null;
          ea_failed_emails?: number | null;
          ea_emails_sq_sent?: number | null;
          ea_email_1_sq_timestamp?: string | null;
          ea_email_2_sq_timestamp?: string | null;
          ea_email_3_sq_timestamp?: string | null;
          ea_email_4_sq_timestamp?: string | null;
          ea_email_5_sq_timestamp?: string | null;
          ea_email_thread?: string | null;
          ea_convo_outcome?: string | null;
          ea_convo_summary?: string | null;
          ea_conversation_thread_id?: string | null;
          la_lead_status?: string | null;
          la_lead_temp?: string | null;
          la_cr_sent?: string | null;
          la_cr_accepted?: string | null;
          la_cr_accepted_at?: string | null;
          la_messages_sent?: number | null;
          la_replies_received?: number | null;
          la_last_reply_timestamp?: string | null;
          la_followup_status?: string | null;
          la_next_fu_datetime?: string | null;
          la_fus_done?: number | null;
          la_qualified?: string | null;
          la_conversation_thread_id?: string | null;
          la_dm_linkedin_vmid?: string | null;
          la_last_thread_sync_timestamp?: string | null;
          la_conversation_thread?: string | null;
          la_convo_outcome?: string | null;
          la_convo_summary?: string | null;
          campaign_id?: string | null;
          campaign_step?: number | null;
          meeting_booked?: string | null;
          meeting_booking_timestamp?: string | null;
          booked_agent?: string | null;
          mtg_invite_sent?: string | null;
          mtg_reschd_invite_sent?: string | null;
          mtg_invite_cancelled?: string | null;
          meeting_id?: string | null;
          meeting_date?: string | null;
          meeting_time?: string | null;
          meeting_status?: string | null;
          mtg_transcript?: string | null;
          mtg_recording?: string | null;
          deal_created?: string | null;
          deal_id?: string | null;
          pipeline_stage?: string | null;
          sales_person?: string | null;
          ovrall_lead_status?: string | null;
          ovrall_lead_temp?: string | null;
          ovrall_convo_summary?: string | null;
          created_at?: string | null;
          updated_at?: string | null;
          outreach_start_timestamp?: string | null;
          lead_source?: string | null;
          sent_for_outreach?: boolean | null;
          sent_to_ca?: boolean | null;
          sent_to_wa?: boolean | null;
          sent_to_ea?: boolean | null;
          sent_to_la?: boolean | null;
          assigned_to_campaign?: boolean | null;
          lga_lead_status?: string | null;
          send_for_outreach?: string | null;
        };
        Update: {
          lead_id?: string;
          company_name?: string | null;
          company_phone?: string | null;
          company_website?: string | null;
          company_linkedin?: string | null;
          company_country?: string | null;
          time_zone?: string | null;
          employee_headcount?: number | null;
          industry_1?: string | null;
          industry_2?: string | null;
          products_services?: string | null;
          company_type?: string | null;
          dm_full_name?: string | null;
          dm_title?: string | null;
          dm_mobile_1?: string | null;
          dm_mobile_2?: string | null;
          dm_email_1?: string | null;
          dm_email_2?: string | null;
          dm_linkedin?: string | null;
          mobile_verified?: boolean | null;
          email_verified?: boolean | null;
          linkedin_verified?: boolean | null;
          company_qualified?: boolean | null;
          dm_qualified?: boolean | null;
          ca_lead_status?: string | null;
          ca_lead_temp?: string | null;
          ca_last_call_outcome?: string | null;
          ca_call_attempts?: number | null;
          ca_call_answered?: number | null;
          ca_last_call_transcript?: string | null;
          ca_last_call_summary?: string | null;
          ca_last_call_recording?: string | null;
          ca_next_call_timestamp?: string | null;
          ca_followup_status?: string | null;
          ca_qualified?: string | null;
          ca_calls_convo_history_summarized?: string | null;
          ca_ovrall_calls_convo_summary?: string | null;
          ca_first_call_schedule?: string | null;
          ca_call_later_aut?: string | null;
          ca_send_info_aut?: string | null;
          wa_lead_status?: string | null;
          wa_lead_temp?: string | null;
          wa_messages_sent?: number | null;
          wa_replies_received?: number | null;
          wa_last_reply_timestamp?: string | null;
          wa_followup_status?: string | null;
          wa_next_fu_datetime?: string | null;
          wa_fus_done?: number | null;
          wa_qualified?: string | null;
          wa_convo_outcome?: string | null;
          wa_conversation_thread?: string | null;
          wa_convo_summary?: string | null;
          wa_first_message_status?: string | null;
          wa_failed_messages?: number | null;
          wa_conversation_thread_id?: string | null;
          wa_number_id?: string | null;
          wa_agent_name?: string | null;
          ea_lead_status?: string | null;
          ea_lead_temp?: string | null;
          ea_emails_sent?: number | null;
          ea_replies_received?: number | null;
          ea_last_reply_timestamp?: string | null;
          ea_followup_status?: string | null;
          ea_next_fu_datetime?: string | null;
          ea_fus_done?: number | null;
          ea_qualified?: string | null;
          ea_first_email_status?: string | null;
          ea_last_email_status?: string | null;
          ea_failed_emails?: number | null;
          ea_emails_sq_sent?: number | null;
          ea_email_1_sq_timestamp?: string | null;
          ea_email_2_sq_timestamp?: string | null;
          ea_email_3_sq_timestamp?: string | null;
          ea_email_4_sq_timestamp?: string | null;
          ea_email_5_sq_timestamp?: string | null;
          ea_email_thread?: string | null;
          ea_convo_outcome?: string | null;
          ea_convo_summary?: string | null;
          ea_conversation_thread_id?: string | null;
          la_lead_status?: string | null;
          la_lead_temp?: string | null;
          la_cr_sent?: string | null;
          la_cr_accepted?: string | null;
          la_cr_accepted_at?: string | null;
          la_messages_sent?: number | null;
          la_replies_received?: number | null;
          la_last_reply_timestamp?: string | null;
          la_followup_status?: string | null;
          la_next_fu_datetime?: string | null;
          la_fus_done?: number | null;
          la_qualified?: string | null;
          la_conversation_thread_id?: string | null;
          la_dm_linkedin_vmid?: string | null;
          la_last_thread_sync_timestamp?: string | null;
          la_conversation_thread?: string | null;
          la_convo_outcome?: string | null;
          la_convo_summary?: string | null;
          campaign_id?: string | null;
          campaign_step?: number | null;
          meeting_booked?: string | null;
          meeting_booking_timestamp?: string | null;
          booked_agent?: string | null;
          mtg_invite_sent?: string | null;
          mtg_reschd_invite_sent?: string | null;
          mtg_invite_cancelled?: string | null;
          meeting_id?: string | null;
          meeting_date?: string | null;
          meeting_time?: string | null;
          meeting_status?: string | null;
          mtg_transcript?: string | null;
          mtg_recording?: string | null;
          deal_created?: string | null;
          deal_id?: string | null;
          pipeline_stage?: string | null;
          sales_person?: string | null;
          ovrall_lead_status?: string | null;
          ovrall_lead_temp?: string | null;
          ovrall_convo_summary?: string | null;
          created_at?: string | null;
          updated_at?: string | null;
          outreach_start_timestamp?: string | null;
          lead_source?: string | null;
          sent_for_outreach?: boolean | null;
          sent_to_ca?: boolean | null;
          sent_to_wa?: boolean | null;
          sent_to_ea?: boolean | null;
          sent_to_la?: boolean | null;
          assigned_to_campaign?: boolean | null;
          lga_lead_status?: string | null;
          send_for_outreach?: string | null;
        };
      };
    };
  };
};
